import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

const TOAST_CLASS = 'custom-toast ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class BrowserToastService {

  constructor(private readonly toastrService: ToastrService) { }

  simpleInfo(message: string, title?: string) {
    return this.toastrService.info(message, title, { toastClass: TOAST_CLASS });
  }

  persistanceInfo(message: string, title?: string) {
    return this.toastrService.info(message, title, {
      disableTimeOut: true,
      closeButton: true,
      toastClass: TOAST_CLASS,
    });
  }

  simpleSuccess(message: string, title?: string) {
    return this.toastrService.success(message, title, { toastClass: TOAST_CLASS });
  }

  persistanceSuccess(message: string, title?: string) {
    return this.toastrService.success(message, title, {
      disableTimeOut: true,
      closeButton: true,
      toastClass: TOAST_CLASS,
    });
  }

  simpleError(message: string, title?: string) {
    return this.toastrService.error(message, title , { toastClass: TOAST_CLASS });
  }

  persistanceError(message: string, title?: string) {
    return this.toastrService.error(message, title, {
      disableTimeOut: true,
      closeButton: true,
      toastClass: TOAST_CLASS,
    });
  }
}
